import React from "react";
import { useDispatch } from "react-redux";

import { IgButton, IgLink, IgTypography } from "@intelligems/ig-theme";
import { useGetOrg } from "@src/api/organizations/get-organization";
import { organizationScriptStatusKey } from "@src/api/queryKeys";
import { IgAlert } from "@src/components/Utils/IgAlert";
import { setDialog } from "@src/store/slices/global";
import { scriptUpdateDocLink } from "@src/utils/linkSheet";
import { openNewTab } from "@src/utils/openNewTab";
import { useQueryClient } from "@tanstack/react-query";

export const CustomEventsESMAlert = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const org = useGetOrg();

  const message = (
    <IgTypography>
      To use Custom Events, upgrade your script to the latest version. This
      ensures compatability and access to the latest improvements. To update
      your script,{" "}
      <IgLink
        onClick={() => {
          openNewTab(scriptUpdateDocLink, "Integration Guides");
        }}
      >
        please follow these steps.
      </IgLink>
    </IgTypography>
  );

  return (
    <IgAlert
      dismissId={"custom-events-esm-alert"}
      title={"Custom Events require an updated script"}
      longMessage={message}
      severity={"warning"}
      buttons={[
        <IgButton
          key={"button-2"}
          variant={"text"}
          onClick={() =>
            void queryClient.invalidateQueries({
              queryKey: organizationScriptStatusKey.org(org.data?.org?.id),
            })
          }
        >
          Recheck
        </IgButton>,
        <IgButton
          key={"button-1"}
          variant={"contained"}
          onClick={() => {
            dispatch(setDialog({ dialog: "scriptTag", open: true }));
          }}
        >
          Add Script
        </IgButton>,
      ]}
      sx={{
        marginBottom: "20px",
      }}
    />
  );
};
